const Type = require('./Type');
const Parser = require('./Parser');
const TransferValidation = require('./TransferValidation');
const TransferPixWithKeyValidation = require('./TransferPixWithKeyValidation');
const BilletValidation = require('./BilletValidation');
const FirstLineValidation = require('./FirstLineValidation');
const error = require('./error');
const { errors } = require('@transfeeradev/api-enums');
const { spreadsheetType } = require('@transfeeradev/api-enums');

class Validation {
  constructor(workbook, data) {
    this._workbook = workbook;
    this._data = data;
    this._parser = new Parser(this._data);
  }

  validate() {
    const validationError = this._validate();

    if (validationError) {
      return validationError;
    }

    const type = new Type(this._data).get();

    switch (type) {
      case spreadsheetType.BILLET:
        return new BilletValidation(this._data).validate();
      case spreadsheetType.TRANSFER:
        return new TransferValidation(this._data).validate();
      case spreadsheetType.TRANSFER_WITH_PIX_KEY:
        return new TransferPixWithKeyValidation(this._data).validate();
      default:
        return error(type);
    }
  }

  _validate() {
    if (this._workbook.SheetNames.length > 1) {
      return error(errors.ptBr.she.WRONG_NUMBER_OF_SHEETS);
    }

    return new FirstLineValidation(this._data).validate();
  }
}

module.exports = Validation;
